import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'

interface Props {
  isDisabled: boolean
  isInvitePending: boolean
}

/** Disabled wins over a pending invite: disabling an invite is how it is revoked. */
const InternalUserStatusChipComponent = ({ isDisabled, isInvitePending }: Props) => {
  if (isDisabled) {
    return (
      <Chip
        text="Disabled"
        className={tw`bg-critical-50`}
        textClassName={tw`text-critical-500`}
        dataTestId="internal-user-status-disabled"
      />
    )
  }

  if (isInvitePending) {
    return (
      <Chip
        text="Invited"
        className={tw`bg-info-200`}
        textClassName={tw`text-info-500`}
        dataTestId="internal-user-status-invited"
      />
    )
  }

  return (
    <Chip
      text="Active"
      className={tw`bg-success-200`}
      textClassName={tw`text-success-500`}
      dataTestId="internal-user-status-active"
    />
  )
}

export const InternalUserStatusChip = memo(InternalUserStatusChipComponent)
